import React from 'react';
var UserAvatarPopoverButtonsContext = React.createContext(true);
UserAvatarPopoverButtonsContext.displayName = 'UserAvatarPopoverButtonsContext';
export default UserAvatarPopoverButtonsContext;
//# sourceMappingURL=UserAvatarPopoverButtonsContext.js.map